export default __webpack_public_path__ + "assets/typography.3dc71e.jpg";